import axios, { AxiosResponse } from "axios";
import { TrackJS } from "trackjs";

export class TrackingService
{
	public GetReferringCategory = async (referrer: string = document.referrer): Promise<string> =>
	{
		const url = `api/referrercategory?url=${referrer}`;
		const response = await axios.get(url) as AxiosResponse;
		return response.data;
	};

	public SubmitWebAPI = (pageViewData): void =>
	{
		axios.post("/api/tracking/pageview", {
			PageType: pageViewData[0].ecomm_pagetype,
			DataLayer: JSON.stringify(pageViewData)
		})
			.catch(function (error)
			{
				let statusCode = 0;

				if (error.response)
				{
					statusCode = error.response.status;
					console.log(`TrackJS API error: ${error.response.status}: ${error.response.data}`);
				}

				if (statusCode > 0)
				{
					// valid status code that we should handle (O means some sort of interruption)
					TrackJS.track("Fun.Tracking PageView error - API request");
				}
			});
	};
}